import { render, staticRenderFns } from "./OnboardingServiceProviderLawyerOffice.vue?vue&type=template&id=399f8a0e"
import script from "./OnboardingServiceProviderLawyerOffice.vue?vue&type=script&lang=js"
export * from "./OnboardingServiceProviderLawyerOffice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports